import "./ProfileSetupThirdScreen.css";
import { useNavigate } from "react-router-dom";
import bannerIcon from "../../assets/images/profile-setup-banner-icon.svg";
import bannerBcIcon from "../../assets/images/profile-setup-founder-header.png";
import headerLeftCornerIcon from "../../assets/images/profile-setup-left-corner.svg";
import headerRightCornerIcon from "../../assets/images/profile-setup-right-corner.svg";
import revealButtonIcon from "../../assets/images/profile-setup-reveal-button.svg";
import analyseButtonIcon from "../../assets/images/profile-setup-analyse-button.svg";
import answerButtonIcon from "../../assets/images/profile-setup-answer-button.svg";
import ROUTE_PATHS from "utils/routePaths";

const ProfileSetupThirdScreen = () => {
  const navigate = useNavigate();

  const handleGetScoreCardClick = () => {
    navigate(ROUTE_PATHS.WSM_SCORE_CARD_INITIAL_SCREEN, { replace: true });
  };

  const handleExploreAppClick = () => {
    navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
  };

  return (
    <div className="wms-mobile-container">
      <div className="profile-setup-third-screen-container">
        <img
          src={bannerBcIcon}
          alt="profile-setup-banner"
          className="header-image"
        />
        <div className="profile-setup-third-header-detail-container">
          <div className="banner-container">
            <img src={bannerIcon} alt="banner-logo" />
            <span>
              The Foundry <span style={{ color: "#FF6B35" }}>Scorecard</span>
            </span>
          </div>
          <div className="divider"></div>
          <div className="title">
            Discover the founder you're wired to be. The Foundry Scorecard
            reveals your archetype, exposes what's slowing your growth, and maps
            your next steps toward peak performance.
          </div>
        </div>
        <div className="profile-setup-third-screen-title-conatiner">
          <img src={headerLeftCornerIcon} alt="header-left-corner" />
          <span>
            Find ur <span style={{ color: "#C1F700" }}>founder score</span>
          </span>
          <img src={headerRightCornerIcon} alt="header-right-corner" />
        </div>
        <div className="profile-setup-third-screen-divider"></div>
        <div className="profile-setup-third-screen-item-container">
          <img src={answerButtonIcon} alt="answer-button-icon" />
          <img src={revealButtonIcon} alt="reveal-button-icon" />
          <img src={analyseButtonIcon} alt="analyse-button-icon" />
        </div>
        <button
          className="get-scorecard-button"
          onClick={handleGetScoreCardClick}
        >
          Get ur Scorecard
        </button>
        <button className="explore-app-button" onClick={handleExploreAppClick}>
          Explore Foundry App
        </button>
      </div>
    </div>
  );
};

export default ProfileSetupThirdScreen;
